var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0425 0.33533C8.25662 0.120942 8.54712 0.000358724 8.85012 9.19649e-05L9.42917 9.19396e-05C9.73151 0.00360279 10.0208 0.123697 10.2368 0.33533L18.0539 8.16771C18.1982 8.31077 18.2793 8.50551 18.2793 8.70866C18.2793 8.91182 18.1982 9.10656 18.0539 9.24962L16.972 10.3315C16.8316 10.4749 16.6394 10.5556 16.4387 10.5556C16.238 10.5556 16.0458 10.4749 15.9054 10.3315L9.13964 3.55057L2.37393 10.3315C2.23087 10.4758 2.03613 10.5569 1.83298 10.5569C1.62982 10.5569 1.43508 10.4758 1.29202 10.3315L0.225356 9.24962C0.081118 9.10656 -1.29619e-05 8.91182 -1.29708e-05 8.70866C-1.29797e-05 8.50551 0.081118 8.31077 0.225356 8.16771L8.0425 0.33533Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.3f564c7d6577105a5b6c4f31ca09827c.svg";
export { ForwardRef as ReactComponent };